import { Platform, type ViewStyle } from 'react-native'
import { buildWebAccountAdminDrawerPushStyle as buildPush } from './accountAdminDrawerPushWeb.builder.helper'

export { buildWebAccountAdminDrawerPushStyle } from './accountAdminDrawerPushWeb.builder.helper'

/** Shifts page content right on web when the org admin drawer is open (avoids text under the panel). */
export function getWebAccountAdminDrawerPushStyle(shiftPx: number): ViewStyle {
  if (Platform.OS !== 'web') {
    return {}
  }
  return buildPush(shiftPx) as ViewStyle
}
